"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  value: "96%",
  label: "Kundenzufriedenheit"
}, {
  value: "73%",
  label: "Start innerhalb einer Woche"
}, {
  value: "79%",
  label: "Weiterempfehlungsrate"
}, {
  value: "15+",
  label: "Jahre Erfahrung"
}];
export default function StatsSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="stats-section" className="bg-foreground text-background py-12 md:py-20 overflow-hidden">
      <div className="page-container">
        <div ref={ref} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col items-center justify-center text-center space-y-4">
              <div className="text-6xl md:text-7xl font-bold font-default tracking-tighter text-background">
                {stat.value}
              </div>
              <div className="text-base md:text-lg font-medium text-background/70 uppercase tracking-widest font-default">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}